/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Platforms_PrInputs */

const en_fc_cmp_platforms_pr = /** @type {(inputs: Fc_Cmp_Platforms_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS, Windows`)
};

/**
* | output |
* | --- |
* | "macOS, Windows" |
*
* @param {Fc_Cmp_Platforms_PrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_platforms_pr = /** @type {((inputs?: Fc_Cmp_Platforms_PrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Platforms_PrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_platforms_pr(inputs)
});
export { fc_cmp_platforms_pr as "fc.cmp.platforms.pr" }